import _ from 'lodash';
import { createSelector } from 'reselect';
import { selectWaiversById } from '../waivers/waiversSelectors';
import { State } from '../../../types';
import { WaiverWorkItemDetailsState } from './waiverWorkItemDetailsReducer';
import { Waiver } from '../../../../types/waiver';
import { WaiverWorkItemDetails, WaiverWorkItem } from '../../../../types/waiverWorkItem';
import { selectWorkItemsById } from './waiverWorkItemsSelectors';

const selectRoot = (state: State): WaiverWorkItemDetailsState => {
  return state.entities.waivers.workItemDetails;
};

export const selectErrorMessage = (state: State): string | null => {
  return selectRoot(state).error ?? null;
};

export const selectLoading = (state: State): boolean => {
  return selectRoot(state).loading;
};

export const selectWorkItemDetails = (state: State): WaiverWorkItemDetails | null => {
  return selectRoot(state).entity ?? null;
};

export const selectWorkItem: (state: State) => WaiverWorkItem | undefined = createSelector(
  [selectWorkItemDetails, selectWorkItemsById],
  (workItemDetails: WaiverWorkItemDetails | null, workItemsById: Record<string, WaiverWorkItem>) => {
    if (workItemDetails) {
      return workItemsById[workItemDetails.workItemId];
    }
    throw new Error('Work item details are undefined');
  }
);

export const selectWorkItemWaivers: (state: State) => Waiver[] = createSelector(
  [selectWorkItem, selectWaiversById],
  (workItem: WaiverWorkItem | undefined, waiversById: Record<string, Waiver>) => {
    if (!workItem) {
      return [];
    }
    return _(waiversById)
      .pick(Array.from(workItem.associatedWaiverIds))
      .values()
      .compact()
      .value();
  },
);
